function formatCurrency(amount) {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    }).format(amount);
}

function formatDate(dateString) {
    if (!dateString) return '';

    if (typeof dateString === 'string') {
        const dateOnlyMatch = dateString.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (dateOnlyMatch) {
            const year = Number(dateOnlyMatch[1]);
            const month = Number(dateOnlyMatch[2]);
            const day = Number(dateOnlyMatch[3]);
            const localDate = new Date(year, month - 1, day, 12, 0, 0, 0);
            return localDate.toLocaleDateString('en-US');
        }
    }

    const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
}

function getDateFromDateTime(dateTimeString) {
    return dateTimeString ? dateTimeString.split('T')[0] : 'N/A';
}

export { formatCurrency, formatDate, getDateFromDateTime };